const path = require('path');
const sourceDir = path.join(__dirname, '/../../');
const photosDir = process.env.PHOTOS_PATH || '\\\\ocm-s-san1\\web-QA\\data\\gallery\\photos\\';

const hostname = window.location.host;
const isLocal = hostname.match('localhost');
const env = hostname.match(/^dev/) ? 'dev' : hostname.match(/^qa/) ? 'qa' : 'prod';

let photosJSONUrl = 'https://coast.noaa.gov/data/gallery/photos/photos.json';

if (env === 'dev') {
    photosJSONUrl = 'https://dev.coast.noaa.gov/data/gallery/photos/photos.json';
} else if (env === 'qa') {
    photosJSONUrl = 'https://qa.coast.noaa.gov/data/gallery/photos/photos.json';
}

export default {
    sourceDir: sourceDir,
    photosDir,
    photosJSONUrl: photosJSONUrl,
    isLocal
};
